import { render, staticRenderFns } from "./BidJudgeList.vue?vue&type=template&id=b638a78c&"
import script from "./BidJudgeList.vue?vue&type=script&lang=js&"
export * from "./BidJudgeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports